import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import getRouteList from "./routes/getRouteList";
import routes from "./routes";
import RouteLogic from "./routes/RouteLogic";
import Loader from "./components/Loader/Loader";
import useAuth from "./hooks/useAuth";
import { useEffect, useState } from "react";
import WhatsNewModal from "./components/Dialogs/WhatsNewModal";
import { localStore } from "./utils/storage";
export const APP_VERSION = "2.0.0";
const routeList = getRouteList(routes);

export default function Page() {
  const { bootStatus } = useAuth();
  const [showWhatsNew, setShowWhatsNew] = useState(false);

  useEffect(() => {
    if (bootStatus === "ready") {
      const seenVersion = localStore.get("seenAppVersion");
      if (seenVersion !== APP_VERSION) {
        setShowWhatsNew(true);
        localStore.set("seenAppVersion", APP_VERSION);
      }
    }
  }, [bootStatus]);

  if (bootStatus !== "ready") {
    return <Loader />;
  }
  return (
    <>
      {showWhatsNew && <WhatsNewModal onClose={() => setShowWhatsNew(false)} />}
      <BrowserRouter>
        <Routes>
          {routeList.map((route) => (
            <Route path={route.path} key={route.path} element={<RouteLogic route={route} />} />
          ))}
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="top-center"
        hideProgressBar={true}
        draggable={false}
        closeOnClick={true}
        closeButton={false}
        theme="colored"
      />
    </>
  );
}
